export default __webpack_public_path__ + "static/media/UserGuide_da_DK.ac9f5f2a.pdf";